export default class CreateProductIssueRequest {
    productId: string;
    name: string;
    code: string;
}